export const actions = {
  SET_SERVICE_HANDLE: 'SERVICES::SET_SERVICE_HANDLE',
};

export function setServiceHandle(serviceHandle, previousServiceHandle = null) {
  return {
    type: actions.SET_SERVICE_HANDLE,
    payload: {serviceHandle, previousServiceHandle},
  };
}
